import { LOCATION_CHANGE } from 'react-router-redux'

const MODAL_OPEN = 'blayzr/modals/OPEN'
const MODAL_CLOSE = 'blayzr/modals/CLOSE'

export const SAVE_ALBUM_MODAL_KEY = 'SAVE_ALBUM'
export const DOWNLOAD_IMAGES_MODAL_KEY = 'DOWNLOAD_IMAGES'

export default function reducer (state = {}, action = {}) {
  const { type, meta } = action
  switch (type) {
    case MODAL_OPEN:
      return {
        ...state,
        [meta.key]: true
      }
    case MODAL_CLOSE:
      return {
        ...state,
        [meta.key]: false
      }
    case LOCATION_CHANGE:
      return {}
    default:
      return state
  }
}

export const openModal = key => ({
  type: MODAL_OPEN,
  meta: { key }
})

export const closeModal = key => ({
  type: MODAL_CLOSE,
  meta: { key }
})



// WEBPACK FOOTER //
// ./src/redux/modals.js